export const AMAZON_URL = "https://www.amazon.com.au/dp/0648387305";

// Edition-specific Amazon (AU) listings.
export const AMAZON_EDITIONS = [
  { label: "Hardcover", url: "https://www.amazon.com.au/dp/0648387321" },
  { label: "Paperback", url: "https://www.amazon.com.au/dp/0648387305" },
  { label: "Kindle", url: "https://www.amazon.com.au/dp/B0HLPJBPWZ" },
];

export const BOOK = {
  title: "Ascent of the Hummingbird",
  author: "Isaac Xavier",
  eyebrow: "A Poetry Collection by Isaac Xavier",
  hook: "Explore the landscape within — a journey from pain to presence.",
  coverImage: "/assets/cover.png",
  hummingbird:
    "https://static.prod-images.emergentagent.com/jobs/64a3bfd5-2a7c-406e-a33f-24d69e3b25bc/images/6f0ed4b1861239958beaffbecd1fd23c12a621e0b4c10b28aab9f0b0707adfdf.jpeg",
  authorImage: "/assets/author.jpg",
};

export const ABOUT = {
  lead:
    "An invitation to explore the landscape within us — to discover that as our relationship with ourselves changes, the life we create around us changes with it.",
  body: [
    "This collection of contemplative poetry moves through pain, healing, vulnerability, and self-discovery, tracing a quiet path from struggle to living.",
    "It is not a book about the writing. It is about what happens in the space between the poem and you — the moment a line meets something you already carry, and quietly names it. Even though each poem can stand alone... together they follow a journey of transformation, encouraging you to feel, to soften, to reconnect with the parts of yourself you had set aside, and, in time, to love more freely.",
  ],
  readerNote:
    "These poems are not written to be admired. They are written to meet you — to sit beside what you feel and let you recognise yourself in it.",
};

export const THEMES = [
  { key: "healing", label: "Healing", note: "Beginning not by becoming someone else, but by remembering." },
  { key: "vulnerability", label: "Vulnerability", note: "The moment before you speak, where you could still hide — and don't." },
  { key: "self-discovery", label: "Self-Discovery", note: "Returning to who you were before fear taught you to hide." },
  { key: "surrender", label: "Surrender", note: "Learning that even the wildest storms break against what yields." },
  { key: "presence", label: "Presence", note: "The body at rest, in the grass, asking nothing of the morning." },
  { key: "transformation", label: "Transformation", note: "A path from struggle to living, one soft step at a time." },
];

export const POEMS = [
  {
    title: "Vulnerability",
    theme: "Vulnerability",
    lines: [
      "There is a moment",
      "before I speak",
      "where I could still",
      "hide.",
      "",
      "I don't.",
      "",
      "And everything",
      "changes.",
    ],
  },
  {
    title: "High Priestess",
    theme: "Trust",
    lines: [
      "You feel it",
      "before she speaks.",
      "",
      "In the way",
      "she does not",
      "hesitate.",
      "",
      "No seeking or",
      "reaching.",
      "",
      "Just",
      "",
      "certainty",
      "",
      "that does not",
      "",
      "ask",
      "",
      "to be believed.",
    ],
  },
  {
    title: "Purpose",
    theme: "Purpose",
    lines: [
      "Do you fear",
      "wasting",
      "your life",
      "through",
      "hesitation?",
      "",
      "Ask yourself this,",
      "",
      "\u201cWhere does",
      "my deepest joy",
      "meet",
      "the world\u2019s",
      "deepest longing?\u201d",
      "",
      "Look there\u2026",
      "",
      "Hesitation",
      "will forget",
      "your name.",
    ],
  },
];

export const AUTHOR = {
  name: "Isaac Xavier",
  role: "Neuro-Movement Specialist · Speaker · Poet",
  bio: [
    "Isaac Xavier is a Neuro-Movement Specialist and speaker whose work explores the relationship between our physical and inner worlds — and how each can shape the other. For more than forty years he has studied movement, strength, neuroscience, and human behaviour, and the ways our thoughts, emotions, beliefs, and lived experiences become expressed through the body.",
    "People often come to him with complex health challenges. While these have physical contributors, Isaac believes they can also reflect a deeper story. A body that has spent years protecting itself may no longer know that it is safe to soften and still stand tall.",
    "Healing begins not only by changing the body, but by understanding the experiences that have shaped it. His writing emerged from this work. The questions he explored with the people he worked with became the questions he asked himself: What if healing begins with awareness? What if the life we long for comes not from becoming someone else, but from remembering who we were before fear, pain, and expectation taught us to hide? Those questions became poems.",
  ],
};

export const HUMMINGBIRD_STORY = {
  heading: "Why the Hummingbird?",
  body: [
    "People often ask why I chose the hummingbird. The answer begins with a gift. Many years ago a dear friend invited me to his daughter Rachel's bat mitzvah. As the day approached, I wondered what I could possibly give her.",
    "Rachel had a way about her that was quite different — quirky. I would watch her move effortlessly from person to person, never trying to impress, never trying to fit in. She simply brought herself. She was like a tiny hummingbird, moving from flower to flower, leaving each one a little brighter than before.",
    "Instead of buying her a gift, I wrote her a poem. Then another emerged. Only later did I realise those poems had opened a door I never knew existed. Everything that followed — every poem, every page, every book — began with a hummingbird. Perhaps that is how many beautiful things begin. Not with ambition. But with giving.",
  ],
};


// PLACEHOLDER testimonials — sample quotes only. Replace with real reader reviews
// once they come in. Names/roles are illustrative and meant to be edited.
export const TESTIMONIALS = [
  {
    quote:
      "I didn't so much read these poems as get read by them. Line after line named things I'd carried for years without words.",
    name: "Mandy Thomson",
    role: "Advance copy",
  },
  {
    quote:
      "Quiet, unhurried, and disarmingly honest. I kept setting the book down just to sit with a single page.",
    name: "Yvette Hansen",
    role: "Advance copy",
  },
  {
    quote:
      "It felt less like a collection to admire and more like a companion — something that met me exactly where I was.",
    name: "Raine Vander",
    role: "Advance copy",
  },
];
